import Content from './Content.vue';
import Header from './Header.vue';
import Footer from './Footer.vue';

export default {
    Content,
    Header,
    Footer,
};



// WEBPACK FOOTER //
// ./src/components/AddPro/index.js